import React, { useEffect, useState } from "react";
import InspectionAuthority from "../components/InspectionAuthority";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import * as userAction from "../../../../redux/actions/userAction";
import {
  ACCESS_DENIED,
  SW_INSPECTION_CONFIGURATION,
} from "../../../../constant/routeContant";
import { API_STATUS, GRID_DEFAULT_PAGE_SIZE } from "../../../../constant/constant";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import Loader from "../../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { PRODUCT_ID } from "../../../../constant/storm-water/constant";
import { useDebounce } from "../../../../utils/useDebounceSearch";

function InspectionAuthorityContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAssignSuccess, setIsAssignSuccess] = useState(false);
  const [isDeleteSuccess, setIsDeleteSuccess] = useState(false);
  const [orgID, setOrgID] = useState("");
  const location = useLocation();
  const setupData = location?.state;
  const [searchUser, setSearchUser] = useState({});
  const debouncedSearchUser = useDebounce(searchUser.searchText, 500);

  const allUsers = useSelector((state) => state.allUsers);
  const InspectorListData = useSelector(
    (state) => state.getSwInspectorListData
  );

  const assignsSwInspectorData = useSelector(
    (state) => state.assignSwInspectorData
  );

  const deleteSwSecondaryInspectionDatas = useSelector(
    (state) => state.deleteSwSecondaryInspectionData
  );

  const deleteSwSecondaryInspectionDataStatus = useSelector(
    (state) => state.deleteSwSecondaryInspectionData.status
  );

  const assignSwInspectorDataStatus = useSelector(
    (state) => state.assignSwInspectorData.status
  );

  const getSwSecondaryInspectorListData = useSelector(
    (state) => state.getSwSecondaryInspectorListData
  );

  const isLoading =
    assignsSwInspectorData.isLoading ||
    deleteSwSecondaryInspectionDatas.isLoading;

  const [secondaryInspector, setSecondaryInspector] = useState([]);
  const [selectedUsers, setselectedUsers] = useState([]);

  const searchSecondaryInspector = (searchText, type, divisionId) => {
    let filtered = secondaryInspector.filter((name) =>
      name.value.toLowerCase().includes(searchText.toLowerCase())
    );
    setselectedUsers(filtered);
  };

  const searchUsers = (
    searchText,
    type,
    divisionId,
    assetType,
    assetId,
    priviledgeId
  ) => {
    setSearchUser({
      searchText: searchText,
      type: type,
      divisionId: divisionId,
      assetType: assetType,
      assetId: assetId,
      priviledgeId: priviledgeId,
    });
  };

  const refData = {
    flags: [4],
  };
  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };

  const defaultData = {
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    search: "",
    UserId: "",
    InspectionDayId: "",
    FrequencyId: "",
  };

  const SwInspectorList = (data) => {
    dispatch(swInspectionAction.getSwInspectorList(data));
  };

  const SwSecondaryInspectorList = (data) => {
    const updatedData = {
      ...data,
      orgID: orgID,
    };
    dispatch(swInspectionAction.getSwSecondaryInspectorList(updatedData));
  };

  useEffect(() => {
    SwInspectorList(defaultData);
    getSwReferenceData(refData);
    setIsAssignSuccess(false);
    setIsDeleteSuccess(false);
  }, []);

  useEffect(() => {
    const res = assignsSwInspectorData?.data?.[0];
    if (
      res?.responseCode === "HBNG015" &&
      assignSwInspectorDataStatus === API_STATUS.SUCCESS &&
      assignsSwInspectorData?.isLoading === false &&
      isAssignSuccess &&
      assignsSwInspectorData?.data
    ) {
      toast(res?.responseMessage || "This Client is Inactive");
      setIsAssignSuccess(false);
    }
  }, [
    assignSwInspectorDataStatus,
    assignsSwInspectorData?.isLoading,
    assignsSwInspectorData?.data?.[0]?.responseCode,
    assignsSwInspectorData?.data?.[0]?.responseMessage,
    isAssignSuccess,
  ]);

  useEffect(() => {
    if (
      assignSwInspectorDataStatus === API_STATUS.SUCCESS &&
      assignsSwInspectorData?.isLoading === false &&
      isAssignSuccess &&
      assignsSwInspectorData?.data?.[0]?.responseCode !== "HBNG015"
    ) {
      const result = assignsSwInspectorData?.data?.result;
      setIsAssignSuccess(false);

      if (Array.isArray(result) && result.length > 0) {
        toast.info(result.join("\n"));
      } else if (typeof result === "string" && result.trim() !== "") {
        toast.info(result);
      } else {
        toast.success("Inspector Assigned Successfully");
      }
    }
  }, [
    assignSwInspectorDataStatus,
    assignsSwInspectorData?.isLoading,
    assignsSwInspectorData?.data?.result,
    isAssignSuccess,
  ]);

  useEffect(() => {
    const res = deleteSwSecondaryInspectionDatas?.data?.[0];
    if (
      res?.responseCode === "HBNG015" &&
      deleteSwSecondaryInspectionDataStatus === API_STATUS.SUCCESS &&
      deleteSwSecondaryInspectionDatas?.isLoading === false &&
      isDeleteSuccess &&
      deleteSwSecondaryInspectionDatas?.data
    ) {
      toast(res?.responseMessage || "This Client is Inactive");
      setIsDeleteSuccess(false);
    }
  }, [
    deleteSwSecondaryInspectionDataStatus,
    deleteSwSecondaryInspectionDatas?.isLoading,
    deleteSwSecondaryInspectionDatas?.data?.[0]?.responseCode,
    deleteSwSecondaryInspectionDatas?.data?.[0]?.responseMessage,
    isDeleteSuccess,
  ]);

  useEffect(() => {
    if (
      deleteSwSecondaryInspectionDataStatus === API_STATUS.SUCCESS &&
      deleteSwSecondaryInspectionDatas?.isLoading === false &&
      isDeleteSuccess &&
      deleteSwSecondaryInspectionDatas?.data?.[0]?.responseCode !== "HBNG015"
    ) {
      setIsDeleteSuccess(false);
      toast(" Secondary Inspector Deleted Successfully");
    }
  }, [deleteSwSecondaryInspectionDatas, isDeleteSuccess]);

  const assignSwInspectorDatas = (data) => {
    setIsAssignSuccess(true);
    const updatedData = {
      ...data,
      orgID: orgID,
    };
    dispatch(swInspectionAction.assignSwInspector(updatedData));
  };

  const deleteSecondaryInspectorList = (payload) => {
    setIsDeleteSuccess(true);
    const updatedPayload = {
      ...payload,
      orgID: orgID,
    };
    dispatch(swInspectionAction.deleteSwSecondaryInspection(updatedPayload));
  };

  const dataBack = {
    title: "Back to Inspection Forms",
    route: SW_INSPECTION_CONFIGURATION,
  };

  useEffect(() => {
    let orgIdForApi;
    if (orgID === 0 || orgID === "0") {
      orgIdForApi = "0";
    } else if (orgID) {
      orgIdForApi = orgID;
    } else {
      orgIdForApi = undefined;
    }
    dispatch(
      userAction.searchAllUsers(
        debouncedSearchUser,
        searchUser.type,
        searchUser.divisionId,
        searchUser.assetType,
        searchUser.assetId,
        17,
        PRODUCT_ID(),
        orgIdForApi
      )
    );
  }, [debouncedSearchUser, orgID]);

  return (
    <>
      {checkPrivileges([12, 96, 97, 98]) ? (
        <>
          {isLoading && <Loader />}
          {/* {assignSwInspectorDataStatus === API_STATUS.SUCCESS &&
        assignsSwInspectorData?.data &&
        isSuccess &&
        toast("Inspector Assigned Successfully")} */}
          {/* {deleteSwSecondaryInspectionDataStatus === API_STATUS.SUCCESS &&
        deleteSwSecondaryInspectionDatas &&
        isSuccess &&
        toast(" Secondary Inspector Deleted Successfully")} */}
          <div>
            <ToastContainer />
          </div>
          <InspectionAuthority
            allUsers={allUsers?.data?.users}
            onSearch={searchUsers}
            isLoading={
              allUsers.isLoading ||
              InspectorListData.isLoading ||
              getSwSecondaryInspectorListData.isLoading
            }
            dataBack={dataBack}
            SwInspectorList={SwInspectorList}
            InspectorListData={InspectorListData}
            getSwReference={getSwReference?.data}
            assignSwInspectorDatas={assignSwInspectorDatas}
            SwSecondaryInspectorList={SwSecondaryInspectorList}
            getSwSecondaryInspectorListData={getSwSecondaryInspectorListData}
            deleteSecondaryInspectorList={deleteSecondaryInspectorList}
            secondaryInspector={secondaryInspector}
            setSecondaryInspector={setSecondaryInspector}
            selectedUsers={selectedUsers}
            searchSecondaryInspector={searchSecondaryInspector}
            setupData={setupData}
            assignsSwInspectorData={assignsSwInspectorData}
            assignSwInspectorDataStatus={assignSwInspectorDataStatus}
            deleteSwSecondaryInspectionDataStatus={
              deleteSwSecondaryInspectionDataStatus
            }
            deleteSwSecondaryInspectionDatas={deleteSwSecondaryInspectionDatas}
            setIsAssignSuccess={setIsAssignSuccess}
            setIsDeleteSuccess={setIsDeleteSuccess}
            setOrgID={setOrgID}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}

export default InspectionAuthorityContainer;
